import { FC } from 'react'
import { Field, FieldProps, FieldRenderProps, useField } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { Props as SwitchProps, Switch } from './Switch'

type Props = {
  name: string
  fieldProps?: FieldProps<boolean, FieldRenderProps<boolean, HTMLElement>>
  validate?: FieldValidator<boolean>
} & SwitchProps

export const SwitchField: FC<Props> = ({ name, fieldProps, validate, ...rest }) => {
  const { input } = useField<boolean>(name, { validate })

  return (
    <Field {...input} {...fieldProps} type="checkbox" value={!!input.value}>
      {({ input }) => (
        <Switch
          {...rest}
          switchProps={{
            ...input,
            onChange: (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => input.onChange(checked),
            checked: !!input.value,
          }}
        />
      )}
    </Field>
  )
}
